import React from "react";
import { Link } from "react-router-dom";
import Discord from "../../assets/discord.svg";

const EndScreen = () => (
  <div className="bg-image">
    <div className="flex h-screen justify-center items-center overflow-y-hidden">
      <div className="box">
        <div className="text-3xl md:text-5xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold text-black pb-6">
          Oops :(
        </div>
        <div className="text-sm md:text-lg lg:text-lg xl:text-xl 2xl:text-2xl mt-2 text-center text-black font-400 px-8%">
          <p>Round 1 is over.</p>
        </div>
        <div className="text-sm md:text-lg lg:text-lg xl:text-xl 2xl:text-2xl mt-2 text-black font-400 px-8% pt-2 text-center">
          But still, you are never too late to be a part of our community!
        </div>
        <div className="mt-8 py-4 px-4 cursor-pointer btn">
          <a
            href="https://discord.com/invite/2yxdXGQB4e"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Discord} alt="Discord" />
          </a>
        </div>
        <Link
          style={{ backgroundColor: "#526bae" }}
          to="/game"
          className="cursor-pointer px-4 py-3 mt-6 rounded-xl text-white text-xs md:text-base xl:text-lg flex justify-center items-center"
        >
          Go back to game
        </Link>
      </div>
    </div>
  </div>
);

export default EndScreen;
